import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  modalWidth: {
    maxWidth: "620px",
    width: "40vw",
    [theme.breakpoints.down("md")]: {
      width: "55vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  userMaintainerBodySectionTitle: {
    marginBottom: 18,
    fontSize: 18,
    lineHeight: "18px",
    fontWeight: "bold",
    color: "#465869",
  },
  userMaintainerBodySection: {
    marginBottom: "28px",
  },
  select: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    "& fieldset": {
      "& legend": {
        fontSize: 0,
        margin: 0,
        "& span": {
          display: "none",
        },
      },
    },
  },
  listSpan: {
    display: "flex",
    alignItems: "center",
    color: "#308CDB",
  },
  removeListSpan: {
    display: "flex",
    alignItems: "center",
    color: "#D92D20",
  },
  chipProject: {
    backgroundColor: "#EDF5FB",
    color: "#308cdb",
    margin: "2px",
  },
  chipLabel: {
    color: "#fff",
    background: "#308cdb",
    fontWeight: 600,
    marginBottom: 5,
  },
  chipLabelProject: {
    color: "#fff",
    background: "#308cdb",
    fontWeight: 600,
    marginTop: 5,
  },
  chipBox: {
    display: "flex",
    flexWrap: "wrap",
    textOverflow: "ellipsis",
    height: 40,
    alignItems: "center",
  },
  chipBoxProject: {
    display: "inline",
    flexWrap: "wrap",
    textOverflow: "ellipsis",
    height: 40,
    alignItems: "center",
  },
  chipMargin: {
    marginTop: "16px",
  },
}));

export default styles;
